/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './routes/_app'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as App403RouteImport } from './routes/_app/403'
import { Route as AppAccountRouteImport } from './routes/_app/account'
import { Route as AppActivityRouteImport } from './routes/_app/activity'
import { Route as AppDocsRouteImport } from './routes/_app/docs'
import { Route as AppEmailsRouteImport } from './routes/_app/emails'
import { Route as AppSettingsRouteImport } from './routes/_app/settings'
import { Route as AppCatalogIndexRouteImport } from './routes/_app/catalog/index'
import { Route as AppErrorsIndexRouteImport } from './routes/_app/errors/index'
import { Route as AppErrorsErrorIdRouteImport } from './routes/_app/errors/$errorId'
import { Route as AppFormsIndexRouteImport } from './routes/_app/forms/index'
import { Route as AppFormsFormIdRouteImport } from './routes/_app/forms/$formId'
import { Route as AppFormsNewRouteImport } from './routes/_app/forms/new'
import { Route as AppPastRunsAtlasRunIdRouteImport } from './routes/_app/past-runs.$atlasRunId'
import { Route as AppRunsIndexRouteImport } from './routes/_app/runs/index'
import { Route as AppRunsRunIdRouteImport } from './routes/_app/runs/$runId'
import { Route as AppStaffIndexRouteImport } from './routes/_app/staff/index'
import { Route as AppToolsIndexRouteImport } from './routes/_app/tools/index'
import { Route as AppRunsRunIdIndexRouteImport } from './routes/_app/runs/$runId/index'
import { Route as AppRunsRunIdActivityRouteImport } from './routes/_app/runs/$runId/activity'
import { Route as AppRunsRunIdDownloadsRouteImport } from './routes/_app/runs/$runId/downloads'
import { Route as AppRunsRunIdEmailRouteImport } from './routes/_app/runs/$runId/email'
import { Route as AppRunsRunIdFinalReviewRouteImport } from './routes/_app/runs/$runId/final-review'

const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const App403Route = App403RouteImport.update({
  id: '/403',
  path: '/403',
  getParentRoute: () => AppRoute,
} as any)
const AppAccountRoute = AppAccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => AppRoute,
} as any)
const AppActivityRoute = AppActivityRouteImport.update({
  id: '/activity',
  path: '/activity',
  getParentRoute: () => AppRoute,
} as any)
const AppDocsRoute = AppDocsRouteImport.update({
  id: '/docs',
  path: '/docs',
  getParentRoute: () => AppRoute,
} as any)
const AppEmailsRoute = AppEmailsRouteImport.update({
  id: '/emails',
  path: '/emails',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsRoute = AppSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRoute,
} as any)
const AppCatalogIndexRoute = AppCatalogIndexRouteImport.update({
  id: '/catalog/',
  path: '/catalog/',
  getParentRoute: () => AppRoute,
} as any)
const AppErrorsIndexRoute = AppErrorsIndexRouteImport.update({
  id: '/errors/',
  path: '/errors/',
  getParentRoute: () => AppRoute,
} as any)
const AppErrorsErrorIdRoute = AppErrorsErrorIdRouteImport.update({
  id: '/errors/$errorId',
  path: '/errors/$errorId',
  getParentRoute: () => AppRoute,
} as any)
const AppFormsIndexRoute = AppFormsIndexRouteImport.update({
  id: '/forms/',
  path: '/forms/',
  getParentRoute: () => AppRoute,
} as any)
const AppFormsFormIdRoute = AppFormsFormIdRouteImport.update({
  id: '/forms/$formId',
  path: '/forms/$formId',
  getParentRoute: () => AppRoute,
} as any)
const AppFormsNewRoute = AppFormsNewRouteImport.update({
  id: '/forms/new',
  path: '/forms/new',
  getParentRoute: () => AppRoute,
} as any)
const AppPastRunsAtlasRunIdRoute = AppPastRunsAtlasRunIdRouteImport.update({
  id: '/past-runs/$atlasRunId',
  path: '/past-runs/$atlasRunId',
  getParentRoute: () => AppRoute,
} as any)
const AppRunsIndexRoute = AppRunsIndexRouteImport.update({
  id: '/runs/',
  path: '/runs/',
  getParentRoute: () => AppRoute,
} as any)
const AppRunsRunIdRoute = AppRunsRunIdRouteImport.update({
  id: '/runs/$runId',
  path: '/runs/$runId',
  getParentRoute: () => AppRoute,
} as any)
const AppStaffIndexRoute = AppStaffIndexRouteImport.update({
  id: '/staff/',
  path: '/staff/',
  getParentRoute: () => AppRoute,
} as any)
const AppToolsIndexRoute = AppToolsIndexRouteImport.update({
  id: '/tools/',
  path: '/tools/',
  getParentRoute: () => AppRoute,
} as any)
const AppRunsRunIdIndexRoute = AppRunsRunIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRunsRunIdRoute,
} as any)
const AppRunsRunIdActivityRoute = AppRunsRunIdActivityRouteImport.update({
  id: '/activity',
  path: '/activity',
  getParentRoute: () => AppRunsRunIdRoute,
} as any)
const AppRunsRunIdDownloadsRoute = AppRunsRunIdDownloadsRouteImport.update({
  id: '/downloads',
  path: '/downloads',
  getParentRoute: () => AppRunsRunIdRoute,
} as any)
const AppRunsRunIdEmailRoute = AppRunsRunIdEmailRouteImport.update({
  id: '/email',
  path: '/email',
  getParentRoute: () => AppRunsRunIdRoute,
} as any)
const AppRunsRunIdFinalReviewRoute = AppRunsRunIdFinalReviewRouteImport.update({
  id: '/final-review',
  path: '/final-review',
  getParentRoute: () => AppRunsRunIdRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/403': typeof App403Route
  '/account': typeof AppAccountRoute
  '/activity': typeof AppActivityRoute
  '/docs': typeof AppDocsRoute
  '/emails': typeof AppEmailsRoute
  '/settings': typeof AppSettingsRoute
  '/errors/$errorId': typeof AppErrorsErrorIdRoute
  '/forms/$formId': typeof AppFormsFormIdRoute
  '/forms/new': typeof AppFormsNewRoute
  '/past-runs/$atlasRunId': typeof AppPastRunsAtlasRunIdRoute
  '/runs/$runId': typeof AppRunsRunIdRouteWithChildren
  '/catalog/': typeof AppCatalogIndexRoute
  '/errors/': typeof AppErrorsIndexRoute
  '/forms/': typeof AppFormsIndexRoute
  '/runs/': typeof AppRunsIndexRoute
  '/staff/': typeof AppStaffIndexRoute
  '/tools/': typeof AppToolsIndexRoute
  '/runs/$runId/activity': typeof AppRunsRunIdActivityRoute
  '/runs/$runId/downloads': typeof AppRunsRunIdDownloadsRoute
  '/runs/$runId/email': typeof AppRunsRunIdEmailRoute
  '/runs/$runId/final-review': typeof AppRunsRunIdFinalReviewRoute
  '/runs/$runId/': typeof AppRunsRunIdIndexRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/403': typeof App403Route
  '/account': typeof AppAccountRoute
  '/activity': typeof AppActivityRoute
  '/docs': typeof AppDocsRoute
  '/emails': typeof AppEmailsRoute
  '/settings': typeof AppSettingsRoute
  '/': typeof AppIndexRoute
  '/errors/$errorId': typeof AppErrorsErrorIdRoute
  '/forms/$formId': typeof AppFormsFormIdRoute
  '/forms/new': typeof AppFormsNewRoute
  '/past-runs/$atlasRunId': typeof AppPastRunsAtlasRunIdRoute
  '/catalog': typeof AppCatalogIndexRoute
  '/errors': typeof AppErrorsIndexRoute
  '/forms': typeof AppFormsIndexRoute
  '/runs': typeof AppRunsIndexRoute
  '/staff': typeof AppStaffIndexRoute
  '/tools': typeof AppToolsIndexRoute
  '/runs/$runId/activity': typeof AppRunsRunIdActivityRoute
  '/runs/$runId/downloads': typeof AppRunsRunIdDownloadsRoute
  '/runs/$runId/email': typeof AppRunsRunIdEmailRoute
  '/runs/$runId/final-review': typeof AppRunsRunIdFinalReviewRoute
  '/runs/$runId': typeof AppRunsRunIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/_app/403': typeof App403Route
  '/_app/account': typeof AppAccountRoute
  '/_app/activity': typeof AppActivityRoute
  '/_app/docs': typeof AppDocsRoute
  '/_app/emails': typeof AppEmailsRoute
  '/_app/settings': typeof AppSettingsRoute
  '/_app/': typeof AppIndexRoute
  '/_app/errors/$errorId': typeof AppErrorsErrorIdRoute
  '/_app/forms/$formId': typeof AppFormsFormIdRoute
  '/_app/forms/new': typeof AppFormsNewRoute
  '/_app/past-runs/$atlasRunId': typeof AppPastRunsAtlasRunIdRoute
  '/_app/runs/$runId': typeof AppRunsRunIdRouteWithChildren
  '/_app/catalog/': typeof AppCatalogIndexRoute
  '/_app/errors/': typeof AppErrorsIndexRoute
  '/_app/forms/': typeof AppFormsIndexRoute
  '/_app/runs/': typeof AppRunsIndexRoute
  '/_app/staff/': typeof AppStaffIndexRoute
  '/_app/tools/': typeof AppToolsIndexRoute
  '/_app/runs/$runId/activity': typeof AppRunsRunIdActivityRoute
  '/_app/runs/$runId/downloads': typeof AppRunsRunIdDownloadsRoute
  '/_app/runs/$runId/email': typeof AppRunsRunIdEmailRoute
  '/_app/runs/$runId/final-review': typeof AppRunsRunIdFinalReviewRoute
  '/_app/runs/$runId/': typeof AppRunsRunIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/reset-password'
    | '/403'
    | '/account'
    | '/activity'
    | '/docs'
    | '/emails'
    | '/settings'
    | '/errors/$errorId'
    | '/forms/$formId'
    | '/forms/new'
    | '/past-runs/$atlasRunId'
    | '/runs/$runId'
    | '/catalog/'
    | '/errors/'
    | '/forms/'
    | '/runs/'
    | '/staff/'
    | '/tools/'
    | '/runs/$runId/activity'
    | '/runs/$runId/downloads'
    | '/runs/$runId/email'
    | '/runs/$runId/final-review'
    | '/runs/$runId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/reset-password'
    | '/403'
    | '/account'
    | '/activity'
    | '/docs'
    | '/emails'
    | '/settings'
    | '/'
    | '/errors/$errorId'
    | '/forms/$formId'
    | '/forms/new'
    | '/past-runs/$atlasRunId'
    | '/catalog'
    | '/errors'
    | '/forms'
    | '/runs'
    | '/staff'
    | '/tools'
    | '/runs/$runId/activity'
    | '/runs/$runId/downloads'
    | '/runs/$runId/email'
    | '/runs/$runId/final-review'
    | '/runs/$runId'
  id:
    | '__root__'
    | '/_app'
    | '/login'
    | '/reset-password'
    | '/_app/403'
    | '/_app/account'
    | '/_app/activity'
    | '/_app/docs'
    | '/_app/emails'
    | '/_app/settings'
    | '/_app/'
    | '/_app/errors/$errorId'
    | '/_app/forms/$formId'
    | '/_app/forms/new'
    | '/_app/past-runs/$atlasRunId'
    | '/_app/runs/$runId'
    | '/_app/catalog/'
    | '/_app/errors/'
    | '/_app/forms/'
    | '/_app/runs/'
    | '/_app/staff/'
    | '/_app/tools/'
    | '/_app/runs/$runId/activity'
    | '/_app/runs/$runId/downloads'
    | '/_app/runs/$runId/email'
    | '/_app/runs/$runId/final-review'
    | '/_app/runs/$runId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  LoginRoute: typeof LoginRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/403': {
      id: '/_app/403'
      path: '/403'
      fullPath: '/403'
      preLoaderRoute: typeof App403RouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/account': {
      id: '/_app/account'
      path: '/account'
      fullPath: '/account'
      preLoaderRoute: typeof AppAccountRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/activity': {
      id: '/_app/activity'
      path: '/activity'
      fullPath: '/activity'
      preLoaderRoute: typeof AppActivityRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/docs': {
      id: '/_app/docs'
      path: '/docs'
      fullPath: '/docs'
      preLoaderRoute: typeof AppDocsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/emails': {
      id: '/_app/emails'
      path: '/emails'
      fullPath: '/emails'
      preLoaderRoute: typeof AppEmailsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings': {
      id: '/_app/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AppSettingsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/catalog/': {
      id: '/_app/catalog/'
      path: '/catalog'
      fullPath: '/catalog/'
      preLoaderRoute: typeof AppCatalogIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/errors/': {
      id: '/_app/errors/'
      path: '/errors'
      fullPath: '/errors/'
      preLoaderRoute: typeof AppErrorsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/errors/$errorId': {
      id: '/_app/errors/$errorId'
      path: '/errors/$errorId'
      fullPath: '/errors/$errorId'
      preLoaderRoute: typeof AppErrorsErrorIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/forms/': {
      id: '/_app/forms/'
      path: '/forms'
      fullPath: '/forms/'
      preLoaderRoute: typeof AppFormsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/forms/$formId': {
      id: '/_app/forms/$formId'
      path: '/forms/$formId'
      fullPath: '/forms/$formId'
      preLoaderRoute: typeof AppFormsFormIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/forms/new': {
      id: '/_app/forms/new'
      path: '/forms/new'
      fullPath: '/forms/new'
      preLoaderRoute: typeof AppFormsNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/past-runs/$atlasRunId': {
      id: '/_app/past-runs/$atlasRunId'
      path: '/past-runs/$atlasRunId'
      fullPath: '/past-runs/$atlasRunId'
      preLoaderRoute: typeof AppPastRunsAtlasRunIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/runs/': {
      id: '/_app/runs/'
      path: '/runs'
      fullPath: '/runs/'
      preLoaderRoute: typeof AppRunsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/runs/$runId': {
      id: '/_app/runs/$runId'
      path: '/runs/$runId'
      fullPath: '/runs/$runId'
      preLoaderRoute: typeof AppRunsRunIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/staff/': {
      id: '/_app/staff/'
      path: '/staff'
      fullPath: '/staff/'
      preLoaderRoute: typeof AppStaffIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/tools/': {
      id: '/_app/tools/'
      path: '/tools'
      fullPath: '/tools/'
      preLoaderRoute: typeof AppToolsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/runs/$runId/': {
      id: '/_app/runs/$runId/'
      path: '/'
      fullPath: '/runs/$runId/'
      preLoaderRoute: typeof AppRunsRunIdIndexRouteImport
      parentRoute: typeof AppRunsRunIdRoute
    }
    '/_app/runs/$runId/activity': {
      id: '/_app/runs/$runId/activity'
      path: '/activity'
      fullPath: '/runs/$runId/activity'
      preLoaderRoute: typeof AppRunsRunIdActivityRouteImport
      parentRoute: typeof AppRunsRunIdRoute
    }
    '/_app/runs/$runId/downloads': {
      id: '/_app/runs/$runId/downloads'
      path: '/downloads'
      fullPath: '/runs/$runId/downloads'
      preLoaderRoute: typeof AppRunsRunIdDownloadsRouteImport
      parentRoute: typeof AppRunsRunIdRoute
    }
    '/_app/runs/$runId/email': {
      id: '/_app/runs/$runId/email'
      path: '/email'
      fullPath: '/runs/$runId/email'
      preLoaderRoute: typeof AppRunsRunIdEmailRouteImport
      parentRoute: typeof AppRunsRunIdRoute
    }
    '/_app/runs/$runId/final-review': {
      id: '/_app/runs/$runId/final-review'
      path: '/final-review'
      fullPath: '/runs/$runId/final-review'
      preLoaderRoute: typeof AppRunsRunIdFinalReviewRouteImport
      parentRoute: typeof AppRunsRunIdRoute
    }
  }
}

interface AppRunsRunIdRouteChildren {
  AppRunsRunIdActivityRoute: typeof AppRunsRunIdActivityRoute
  AppRunsRunIdDownloadsRoute: typeof AppRunsRunIdDownloadsRoute
  AppRunsRunIdEmailRoute: typeof AppRunsRunIdEmailRoute
  AppRunsRunIdFinalReviewRoute: typeof AppRunsRunIdFinalReviewRoute
  AppRunsRunIdIndexRoute: typeof AppRunsRunIdIndexRoute
}

const AppRunsRunIdRouteChildren: AppRunsRunIdRouteChildren = {
  AppRunsRunIdActivityRoute: AppRunsRunIdActivityRoute,
  AppRunsRunIdDownloadsRoute: AppRunsRunIdDownloadsRoute,
  AppRunsRunIdEmailRoute: AppRunsRunIdEmailRoute,
  AppRunsRunIdFinalReviewRoute: AppRunsRunIdFinalReviewRoute,
  AppRunsRunIdIndexRoute: AppRunsRunIdIndexRoute,
}

const AppRunsRunIdRouteWithChildren = AppRunsRunIdRoute._addFileChildren(
  AppRunsRunIdRouteChildren,
)

interface AppRouteChildren {
  App403Route: typeof App403Route
  AppAccountRoute: typeof AppAccountRoute
  AppActivityRoute: typeof AppActivityRoute
  AppDocsRoute: typeof AppDocsRoute
  AppEmailsRoute: typeof AppEmailsRoute
  AppSettingsRoute: typeof AppSettingsRoute
  AppIndexRoute: typeof AppIndexRoute
  AppErrorsErrorIdRoute: typeof AppErrorsErrorIdRoute
  AppFormsFormIdRoute: typeof AppFormsFormIdRoute
  AppFormsNewRoute: typeof AppFormsNewRoute
  AppPastRunsAtlasRunIdRoute: typeof AppPastRunsAtlasRunIdRoute
  AppRunsRunIdRoute: typeof AppRunsRunIdRouteWithChildren
  AppCatalogIndexRoute: typeof AppCatalogIndexRoute
  AppErrorsIndexRoute: typeof AppErrorsIndexRoute
  AppFormsIndexRoute: typeof AppFormsIndexRoute
  AppRunsIndexRoute: typeof AppRunsIndexRoute
  AppStaffIndexRoute: typeof AppStaffIndexRoute
  AppToolsIndexRoute: typeof AppToolsIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  App403Route: App403Route,
  AppAccountRoute: AppAccountRoute,
  AppActivityRoute: AppActivityRoute,
  AppDocsRoute: AppDocsRoute,
  AppEmailsRoute: AppEmailsRoute,
  AppSettingsRoute: AppSettingsRoute,
  AppIndexRoute: AppIndexRoute,
  AppErrorsErrorIdRoute: AppErrorsErrorIdRoute,
  AppFormsFormIdRoute: AppFormsFormIdRoute,
  AppFormsNewRoute: AppFormsNewRoute,
  AppPastRunsAtlasRunIdRoute: AppPastRunsAtlasRunIdRoute,
  AppRunsRunIdRoute: AppRunsRunIdRouteWithChildren,
  AppCatalogIndexRoute: AppCatalogIndexRoute,
  AppErrorsIndexRoute: AppErrorsIndexRoute,
  AppFormsIndexRoute: AppFormsIndexRoute,
  AppRunsIndexRoute: AppRunsIndexRoute,
  AppStaffIndexRoute: AppStaffIndexRoute,
  AppToolsIndexRoute: AppToolsIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  LoginRoute: LoginRoute,
  ResetPasswordRoute: ResetPasswordRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
